import { useParams } from "react-router-dom";
import CategoryPage from "@/pages/CategoryPage";
import CityPage from "@/pages/CityPage";
import NotFound from "@/pages/NotFound";
import { ALL_CATS, CITIES } from "@/i18n/slugs";

export default function SeoResolver({ lang }) {
  const { slug } = useParams();
  const prefix = lang === "nl" ? "offerte-" : "devis-";
  if (!slug || !slug.startsWith(prefix)) return <NotFound />;
  const rest = slug.slice(prefix.length);
  const slugOf = (c) => (lang === "nl" ? c.nl.slug : c.fr.slug);

  const cat = ALL_CATS.find((c) => slugOf(c) === rest);
  if (cat) return <CategoryPage category={cat.key} />;

  for (const c of ALL_CATS) {
    const s = slugOf(c);
    if (rest.startsWith(s + "-")) {
      const citySlug = rest.slice(s.length + 1);
      const city = CITIES.find((v) => (lang === "nl" ? v.nlSlug : v.frSlug) === citySlug);
      if (city) return <CityPage category={c.key} city={city.key} />;
    }
  }
  return <NotFound />;
}
